import React, { useState } from "react";
import { MapMarker, Organization } from "../common/ObjectTypes";
import {
  AddIcon,
  DeleteIcon,
  PawIcon,
  getIconImage,
} from "../common/ProjectIcons";
import TextInput from "../common/TextInput";
import { Link } from "react-router-dom";
import PageComingSoon from "../common/PageComingSoon";
import { MoonLoader } from "react-spinners";
import tailwindClassnames from "../common/TaildwindClassnames";

type MapMarkersListTypes = {
  mapMarkers: MapMarker[];
  customMapMarkers: MapMarker[];
  organizations: Organization[];
  selectedMapMarker: MapMarker;
  mapMarkerToAdd: MapMarker;
  addMapMarker: boolean;
  onClickAdd: Function;
  onSelectMapMarker: Function;
  onChange: Function;
  onChangeNewMapMarker: Function;
  onCancelEdit: Function;
  onCancelAdd: Function;
  onSaveNew: Function;
  onUpdateMapMarker: Function;
  onDelete: Function;
  selectMapMarkersPage: boolean;
  onSelectMapMarkerForVideo?: Function;
  isMapMarkerIncluded?: Function;
  onSelectMapMarkerForCatalogue?: Function;
  isCatalogueMapMarkerIncluded?: Function;
  onSelectAllMapMarkers?: Function;
  areAllMapMarkersSelected?: boolean;
  isLoadingForCatalogueSelectAll?: boolean;
  onSelectAllMapMarkersForVideo?: Function;
  isLoadingForVideo?: boolean;
  isDisabled?: boolean;
};

const MapMarkersList = ({
  mapMarkers,
  customMapMarkers,
  organizations,
  selectMapMarkersPage,
  onSelectMapMarker,
  onSelectMapMarkerForVideo,
  isMapMarkerIncluded,
  onSelectMapMarkerForCatalogue,
  isCatalogueMapMarkerIncluded,
  onSelectAllMapMarkers,
  areAllMapMarkersSelected,
  isLoadingForCatalogueSelectAll,
  onSelectAllMapMarkersForVideo,
  isLoadingForVideo,
  isDisabled,
}: MapMarkersListTypes) => {
  const [customMapMarkersTab, setCustomMapMarkersTab] = useState(false);
  const [mapMarkersTab, setMapMarkersTab] = useState(true);
  const getOrgNameById = (id: any) => {
    let orgName = organizations?.find((org) => org.organizationId === id);
    return orgName?.name || null;
  };

  return (
    <div className={!selectMapMarkersPage ? "p-6 space-y-6" : "space-y-6"}>
      {/* Header */}
      {!selectMapMarkersPage && (
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-semibold text-gray-800">
            Map Marker Admin
          </h1>
        </div>
      )}

      {/* Tabs + Add Button */}
      <div className="flex items-center justify-between">
        {/* Tabs */}
        <div className="inline-flex rounded-full shadow-sm overflow-hidden border border-gray-200">
          <button
            className={`px-4 py-2 text-sm font-medium transition ${
              mapMarkersTab
                ? "bg-tealBlue-400 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => {
              setCustomMapMarkersTab(false);
              setMapMarkersTab(true);
            }}
            type="button"
          >
            Map Markers
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium transition ${
              customMapMarkersTab
                ? "bg-tealBlue-400 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => {
              setCustomMapMarkersTab(true);
              setMapMarkersTab(false);
            }}
            type="button"
          >
            Custom Map Markers
          </button>
        </div>

        {/* Add Button */}
        {!selectMapMarkersPage && (
          <Link
            to="/mapMarker/add"
            className="px-4 py-2 rounded-full text-sm font-medium text-white bg-tealBlue-500 hover:bg-tealBlue-600 shadow transition"
          >
            + Add Map Marker
          </Link>
        )}
      </div>

      {/* Table */}
      <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
        <table className="w-full border-collapse text-sm text-gray-700">
          <thead className="bg-gray-50 border-b">
            <tr>
              {selectMapMarkersPage && (
                <th className="px-4 py-3 text-left font-medium text-gray-600">
                  {!customMapMarkersTab && (
                    <>
                      <div className="flex flex-col items-center">
                        <div className="mb-1">Select All Map Markers</div>
                        {isLoadingForCatalogueSelectAll || isLoadingForVideo ? (
                          <div className="flex justify-center items-center">
                            <MoonLoader color="#4f5a2d" size={20} />
                          </div>
                        ) : (
                          <div className="flex justify-center items-center mt-1">
                            <input
                              type="checkbox"
                              className="h-4 w-4 text-tealBlue-500 rounded border-gray-300 focus:ring-tealBlue-400"
                              onChange={() => {
                                if (onSelectAllMapMarkers)
                                  onSelectAllMapMarkers();
                                if (onSelectAllMapMarkersForVideo)
                                  onSelectAllMapMarkersForVideo();
                              }}
                              checked={areAllMapMarkersSelected}
                              disabled={isDisabled}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </th>
              )}
              <th className="px-4 py-3 text-left font-medium text-gray-600">
                Icon
              </th>
              <th className="px-4 py-3 text-left font-medium text-gray-600">
                Name
              </th>
              <th className="px-4 py-3 text-left font-medium text-gray-600">
                Description
              </th>
              {customMapMarkersTab && (
                <th className="px-4 py-3 text-left font-medium text-gray-600">
                  Organization
                </th>
              )}
              <th className="px-4 py-3 text-left font-medium text-gray-600">
                Videos
              </th>
              <th className="px-4 py-3 text-left font-medium text-gray-600">
                Location
              </th>
            </tr>
          </thead>

          <tbody>
            {(customMapMarkersTab ? customMapMarkers : mapMarkers)?.map(
              (mapMarker: MapMarker, index: number) => {
                const rowClass = index % 2 === 0 ? "bg-white" : "bg-gray-50";

                return (
                  <tr
                    key={mapMarker.mapMarkerId}
                    className={`${rowClass} hover:bg-gray-100 transition`}
                  >
                    {selectMapMarkersPage && (
                      <td className="px-4 py-2">
                        <div className="flex justify-center items-center">
                          <input
                            type="checkbox"
                            className="h-4 w-4 text-tealBlue-500 rounded border-gray-300 focus:ring-tealBlue-400"
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              if (onSelectMapMarkerForCatalogue)
                                onSelectMapMarkerForCatalogue(
                                  mapMarker,
                                  isChecked
                                );
                              if (onSelectMapMarkerForVideo)
                                onSelectMapMarkerForVideo(mapMarker, isChecked);
                            }}
                            checked={
                              (isMapMarkerIncluded &&
                                isMapMarkerIncluded(mapMarker.mapMarkerId)) ||
                              (isCatalogueMapMarkerIncluded &&
                                isCatalogueMapMarkerIncluded(
                                  mapMarker.mapMarkerId
                                )) ||
                              (areAllMapMarkersSelected &&
                                !customMapMarkersTab &&
                                mapMarker.organizationId ===
                                  "b1df7f5a-5ed7-4ae9-97dc-e78b9137a0b3")
                            }
                            disabled={isDisabled}
                          />
                        </div>
                      </td>
                    )}
                    <td
                      className="px-4 py-2 text-center cursor-pointer"
                      onClick={() =>
                        !selectMapMarkersPage &&
                        onSelectMapMarker(mapMarker.mapMarkerId)
                      }
                    >
                      <div className="flex justify-center">
                        <div className="[&>img]:brightness-50 [&>img]:h-5">
                          {getIconImage(mapMarker.iconID.toString())}
                        </div>
                      </div>
                    </td>
                    <td
                      className="px-4 py-2 cursor-pointer"
                      onClick={() =>
                        !selectMapMarkersPage &&
                        onSelectMapMarker(mapMarker.mapMarkerId)
                      }
                    >
                      {mapMarker.name}
                    </td>
                    <td
                      className="px-4 py-2 cursor-pointer"
                      onClick={() =>
                        !selectMapMarkersPage &&
                        onSelectMapMarker(mapMarker.mapMarkerId)
                      }
                    >
                      {mapMarker.description}
                    </td>
                    {customMapMarkersTab && (
                      <td
                        className="px-4 py-2 cursor-pointer"
                        onClick={() =>
                          !selectMapMarkersPage &&
                          onSelectMapMarker(mapMarker.mapMarkerId)
                        }
                      >
                        {getOrgNameById(mapMarker.organizationId)}
                      </td>
                    )}
                    <td
                      className="px-4 py-2 text-center cursor-pointer"
                      onClick={() =>
                        !selectMapMarkersPage &&
                        onSelectMapMarker(mapMarker.mapMarkerId)
                      }
                    >
                      {mapMarker.videos?.length}
                    </td>
                    <td
                      className="px-4 py-2 cursor-pointer"
                      onClick={() =>
                        !selectMapMarkersPage &&
                        onSelectMapMarker(mapMarker.mapMarkerId)
                      }
                    >
                      {mapMarker.latitude}, {mapMarker.longitude}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MapMarkersList;
